import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoginService } from 'app/services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment, productModels } from '../../../environments/environment';
import { Job } from '../../entities/Job';
import { JobService } from '../../services/job.service';
import { ConfigService } from '../../services/config.service';
import { Observable, Subscription } from 'rxjs';
import { delay } from 'q';
import { AppConfig } from '../../app.config';
import { Customer } from '../../entities/Customer';
import { Responsible } from '../../entities/SalesPerson';
import { SalesPersonService } from '../../services/sales-person.service';
import { EmailAccountService } from '../../services/email-account.service';
import { Title } from '@angular/platform-browser';
import { TranslationService } from "app/services/translation.service";
import { Translation } from 'app/entities/Translation';
import { TranslationPipe } from 'app/pipes/TranslationPipe';

//import {LoginService} from "../services/login.service";

declare var $: any;

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],


})
export class ToolbarComponent implements OnInit, OnDestroy {

  public loginBtnText: string;
  public isLoggedIn: boolean;
  public projectVersion: string;
  public showJobs: boolean;
  private userLoggedInName: string = '';
  salespersons: Responsible[];
  public translations: Map<string, Translation>;
  private subscription: any;
  private jobRelevanceSub: any;
  private jobSubscription: any;
  private routeSubscription: any;
  private translationSub: Subscription;
  private modalShowHandler: () => void;
  Jobs: Job[];
  ChosenJob: Job;
  jobInput: Job;
  currentRoute: string = '';
  productModel: number;// = environment.productModel;
  siteTitle: string;
  siteShortTitle: string;
  public productModels = productModels;
  language: string;
  translationsLoaded: boolean = false;

  constructor(private loginService: LoginService,
    private jobservice: JobService,
    private configService: ConfigService,
    private router: Router, private config: AppConfig,
    private emailService: EmailAccountService,
    private salesPersonService: SalesPersonService,
    private titleService: Title,
    private translationService: TranslationService,
    private activatedRoute: ActivatedRoute,
    private translationPipe: TranslationPipe,
  ) {
    this.productModel = this.config.getConfig('productModel');
    this.siteTitle = this.config.getConfig('site.title');
    this.siteShortTitle = this.config.getConfig('site.short-title');
    this.titleService.setTitle(this.siteTitle);
    this.translationSub = this.translationService.language.subscribe((language: string) => {
      this.language = language;
    }, () => { }, () => { });

    this.modalShowHandler = () => {
      this.closeSidebarForModal();
    };
  }


  ngOnInit() {
    this.salesPersonService.getAllSalesPersonsAsSalesPerson().subscribe(s => {
      let user = s.find(r => r.Code.toUpperCase() == this.loginService.getLoggedInUserID().toUpperCase());
      this.userLoggedInName = user.Name;
    });
    this.jobRelevanceSub = this.configService.observableIsJobsRelevant.subscribe(isIt => {
      this.changejobRelevance(isIt);
    });
    this.jobSubscription = this.configService.observableJob.subscribe(x => {
      this.jobInput = Object.assign({}, this.configService.chosenJob);
    });
    this.routeSubscription = this.configService.observableRoute.subscribe(route => {
      if (route != undefined) {
        this.currentRoute = route;
        $('body').removeClass('control-sidebar-open');
      }
    });

    $(document).on('show.bs.modal.toolbar', '.modal', this.modalShowHandler);

    this.setTranslations();


    this.projectVersion = environment.projectVersion;
    this.isLoggedIn = true;
    if (this.loginService.isLoggedIn()) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
    this.subscription = this.loginService.checkAccessToken().subscribe(x => {
      this.isLoggedIn = x;
      this.loginBtnText = x != false ? this.translationPipe.transform('LogOut') : this.translationPipe.transform('LogIn');
      if (!x) {
        this.resetShellLayout();
      }
    });

    //this.ChosenJob = this.configService.chosenJob;
    this.jobInput = Object.assign({}, this.configService.getJobFromSessionStorage());
    if (this.productModel == productModels.Premium) {
      let jobSub = this.jobservice.GetJobs().subscribe(jobs => {
        this.Jobs = jobs, jobSub.unsubscribe()
      }, (err) => {
      });
    }


  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.jobRelevanceSub.unsubscribe();
    this.jobSubscription.unsubscribe();
    this.translationSub.unsubscribe()
    $(document).off('show.bs.modal.toolbar', '.modal', this.modalShowHandler);
  }

  setLoginStatus() {

  }

  tryLogout() {
    this.loginService.logout();
    this.resetShellLayout();
    this.router.navigate([this.configService.getLanguageFromURL() + '/login']);
  }

  changeJob(jobNo: string) {

    jobNo = jobNo.trim();
    if (jobNo != 'Alle sager') {
      if (this.Jobs.filter(x => x.No == jobNo)[0] != null) {
        this.jobservice.GetJob(jobNo).subscribe(x => {
          this.ChosenJob = x;
          this.configService.changeJob(this.ChosenJob);
        });
      }
    } else {
      this.ChosenJob = null;
      this.ChosenJob = new Job();
      this.ChosenJob.No = jobNo;
      this.configService.changeJob(this.ChosenJob);
    }
  }

  checkForDropdown(jobNo) {
    if (jobNo.trim() == '') {
      this.jobInput.No = this.jobInput.No + ' ';
    }
  }


  changejobRelevance(isIt) {
    (async () => {
      // Do something before delay
      await delay(1);
      this.showJobs = isIt;
    })();
  }

  ResetJobInput() {
    this.jobInput.No = 'Alle sager';
    this.changeJob(this.jobInput.No);
  }

  setTranslations() {
    this.translationService.loadTranslations();
      this.translationService.translationsSub.subscribe(translations => {
      // Get translations from the service
      if (translations !== null && Object.keys(translations).length > 0) {
        // Check to make sure that translations is loaded and in the correct language
        this.translationService.getLanguageSubject().subscribe(language => {
          // This check is done to only set translationsLoaded if the language in the translation object matches the active language. Sometimes it returns the old language object as the first call
          if (language == translations[Object.keys(translations)[0]].Language_Code) {
            this.translationsLoaded = true
          }
        })
      }
    })
  }

  private resetShellLayout() {
    $('body').removeClass('sidebar-mini sidebar-collapse sidebar-open control-sidebar-open');
    $('body').css('overflow', 'auto');
  }

  private closeSidebarForModal() {
    $('body').removeClass('sidebar-open control-sidebar-open');
  }
}




// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/toolbar/toolbar.component.ts